import { DataEntry } from '../../../lib/types';
import { updateCourse } from '../../../modules/course/api';
import { Course, UpdateCoursePayload } from '../../../modules/course/types';

export const updateCourseUseCase = async (
  courseId: number, payload: UpdateCoursePayload,
): Promise<DataEntry<Course>> => {
  return updateCourse(courseId, payload);
};